//import Vue from 'vue'
import Vue from 'vue/dist/vue.esm'
import 'babel-polyfill'
import ImageUploader from '../image_uploader.vue'

/**
[使い方]
railsのviewにカスタムタグを記述
<image-uploader></image-uploader>

attached_imagesテーブルのidが分かっている場合はpropsでセットする
確認画面から入力画面に戻ってきた時の再表示に使用する
<image-uploader image_id="1"></image-uploader>

hidden_id_nameを指定する事で画像IDのパラメータ名を変更できる
<image-uploader image_id="1" hidden_id_name="image_id[]"></image-uploader>
*/

document.addEventListener('DOMContentLoaded', () => {
  let elements = document.getElementsByClassName('image-uploader');
  for(let index=0; index < elements.length; index++) {
    let element = elements[index];
    const id = 'image-uploader-' + (index + 1);
    element.setAttribute('id', id);

    setTimeout(function(id) {
      new Vue({
        el: '#' + id,
        components: { 'image-uploader': ImageUploader }
      })
    }, 150, id);
  }
})